<template lang="pug">
.novo-apontamento
  .apontamento
    PSelect(
      :customVmodel="seletorApontamentos()"
      title="apontamento"
      name="apontamento"
      labelItem="name"
      :allowEmpty="false"
    )
  .comparacao
    PSelect(
      :customVmodel="seletorComparacaoes()"
      title=""
      name="comparacao"
      labelItem="name"
      :allowEmpty="false"
    )
  .input-time
    PTimeCountField(
      :customVmodel="customMinVModel()"
      label=""
      name="min"
      decimal
    )

  template
    .segunda-parte-string(v-if="regraApontamento.comparacao.id !== 'between'")
      .texto hora(s)

    .segunda-parte-between(v-else)
      .texto e

      .input-time
        PTimeCountField(
          :customVmodel="customMaxVModel()",
          label="",
          name="max",
          decimal
        )

      .texto hora(s)

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NovoApontamento',
  props: {
    indice: {type: Number, required: true},
    regraApontamento: {type: Object, required: true},
    comparacoes: {type: Array, required: true}
  },
  computed: {
    ...mapState('approvalsRules/details', ['apontamentos'])
  },
  methods: {
    seletorApontamentos () {
      return {
        get: () => {
          const { id } = this.regraApontamento.apontamento
          return {
            loaded: this.apontamentos,
            selected: this.apontamentos.find(apontamento => apontamento.id === id)
          }
        },
        set: (novoValor) => {
          this.$store.commit(
            'approvalsRules/details/atualizaRegraDeApontamento',
            {indice: this.indice, apontamento: novoValor.selected}
          )
        }
      }
    },
    seletorComparacaoes () {
      return {
        get: () => {
          const { id } = this.regraApontamento.comparacao
          return {
            loaded: this.comparacoes,
            selected: this.comparacoes.find(comparacao => comparacao.id === id)
          }
        },
        set: (novoValor) => {
          this.$store.commit(
            'approvalsRules/details/atualizaRegraDeApontamento',
            {indice: this.indice, comparacao: novoValor.selected}
          )
        }
      }
    },
    customMinVModel () {
      return {
        get: () => this.regraApontamento.min,
        set: (novoValor) => {
          this.$store.commit(
            'approvalsRules/details/atualizaRegraDeApontamento',
            {indice: this.indice, min: novoValor}
          )
        }
      }
    },
    customMaxVModel () {
      return {
        get: () => this.regraApontamento.max,
        set: (novoValor) => {
          this.$store.commit(
            'approvalsRules/details/atualizaRegraDeApontamento',
            {indice: this.indice, max: novoValor}
          )
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.novo-apontamento {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 150px 190px 55px 125px;
  column-gap: 5px;
  align-items: end;

  .segunda-parte-string {
    align-self: center;
  }

  .segunda-parte-between {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: auto 55px auto;
    column-gap: 5px;
    align-items: center;
  }
}
</style>
